<template>
<div id="app">
  <!-- <f7-statusbar :theme="statusColor"></f7-statusbar> -->
  <left-panel v-if="connected" :context="context"></left-panel>
  <right-panel v-if="connected"></right-panel>
  <!-- <div v-bind:class="{hiddenBlock : hideLeftPanel}" id="panel">
			<left-panel></left-panel>
		</div> -->
  <f7-views>
    <!-- TLV 09/12/2019
				J'ai mis le paramètre domCache à false pour éviter l'erreur de sélection de compte bancaire
				au deuxième affichage des new request to pay ou direct payments. M'en parler si ça pose problème
			-->
    <!-- <f7-view :domCache="false" :uniqueHistory="false" id="main-view" navbar-through :dynamic-navbar="true" main url="/login/"> -->
    <f7-view :domCache="false" :uniqueHistory="false" id="main-view" main :url="url">
      <!-- <f7-navbar fill :style="titleNavBar">
					<f7-nav-center sliding></f7-nav-center>
				</f7-navbar> -->
      <!-- <web-header></web-header> -->
      <web-header v-if="connected && !isSmartphoneOS"
        :key="'web-header-' + webheaderKey"
        :context="context">
      </web-header>
      <mobile-header v-if="connected"
        :key="'mobile-header-' + webheaderKey"
        :context="context">
      </mobile-header>
      <!-- <mobile-header></mobile-header> -->
      <f7-pages></f7-pages>
      <!-- <bottom-toolbar class="showSmallScreenOnly" :key="'bottom-toolbar-' + webheaderKey"></bottom-toolbar> -->
    </f7-view>
  </f7-views>

  <cm-popups></cm-popups>
  <!-- <enroll-message></enroll-message> -->
  <user-guide></user-guide>

</div>
</template>

<script>
// import LeftPanel from '@/components/leftpanel/CMLeftPanel.vue'
// import enrollMessage from '@/components/common/enrollMessage.vue'
// import FormDevis from '@/components/forms/CMDevis.vue'
// import FormReglament from '@/components/forms/CMReglament.vue'
// import dynamicStyleMixin from './mixins/dynamicStyleMixin'
// import {loadPage} from '@/helpers/routing'
import WebHeader from '@/components/menus/WebHeader.vue'
import MobileHeader from '@/components/menus/MobileHeader.vue'
import LeftPanel from '@/components/menus/MobileLeftPanel.vue'
import RightPanel from '@/components/common/RightPanel.vue'

import design from '@/design/design.json'

import networkMixin from './mixins/networkMixin'

import CMPopup from '@/popups/Popups.vue'
import userGuidePopovers from '@/components/common/userGuidePopovers.vue'
// import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

import {loadPage, reloadPage} from '@/helpers/routing'

/* eslint-disable no-tabs */
/* eslint-disable indent */
export default {
  name: 'MoneyRoad',
  mixins: [networkMixin], //  dynamicStyleMixin],
  components: {
    // 'left-panel': LeftPanel,
    // 'cm-devis': FormDevis,
    // 'cm-reglament': FormReglament,
    // 'enroll-message': enrollMessage,
    'web-header': WebHeader,
    'left-panel': LeftPanel,
    'cm-popups': CMPopup,
    'user-guide': userGuidePopovers,
    // 'bottom-toolbar': bottomToolbar,
    'mobile-header': MobileHeader,
    'right-panel': RightPanel
  },
  data: () => {
    return {
      context: 'RTP',
      design: design,
      service: '',
      connected: false,
      homepageSelected: false,
      webheaderKey: false,
      defaultService: 'Direct Debit',
      url: ''
    }
  },
  created () {
    this.context = this.getContext()
    this.$engine.setService(this.context)
    var data = this.getJsonFromUrl(window.location.href)
    if (data.OTP && data.email && data.ressource) {
      this.url = '/OTP/' + data.email + '/' + data.OTP + '/' + data.ressource
    } else if (data.sendDocumentsFromApplication === '1') {
      this.url = '/OTP/' + data.email + '/' + data.OTP + '/sendDocumentsFromApplication'
    } else if (data.paymentFromApplication === '1') {
      this.url = '/OTP/' + data.email + '/' + data.OTP + '/paymentFromApplication'
    } else if (data.loading === '1') {
      this.url = '/loading/'
    } else if (this.$engine.applicationMode === 'standard') {
      this.url = '/login/'
    } else {
      this.url = ''
    }
    /** TLV - TBR 27/11/2017
     * Affichage du menu de gauche seulement quand un service est actif,
     * Quand il n'y a pas de service sélectionné (sur la page de connexion par exemple),
     * Le menu de gauche n'est pas affiché
     */
    this.$engine.services.directPayments.filter.smartphoneStorage = window.innerWidth <= 992
    this.$bus.$on('service:change', () => {
      this.service = this.$engine.user.currentService.name
      this.$bus.$emit('refresh-cache-menu')
    })
    this.$bus.$on('refresh-cache-menu', () => {
      this.service = this.$engine.user.currentService.name
    })
    let that = this
    this.$bus.$off('reload-app')
    this.$bus.$on('reload-app', () => {
      that.$engine.setService(that.getContext())
      that.context = that.$engine.getService()
      that.webheaderKey = !that.webheaderKey
      that.$bus.$emit('reload-homepage')
      loadPage(that, {
        url: '/home/' + that.getContext()
      })
    })
  },
  mounted () {
    let that = this
    this.$bus.$on('login', function (login) {
      if (!login && !this.$engine.services.directPayments.filter.smartphoneStorage) {
        this.$engine.user.currentService.name = ''
        this.$bus.emit('service:change', '')
      } else if (login) {
        // TLV 08/02/2021 : showing web header unless we are using an iframe
        if (login !== 'iframe') {
          that.connected = true
        }
        if (this.$engine.user.currentService.id != null) {
          this.$bus.emit('service:change', that.$engine.services.getServiceIdByName(that.defaultService))
        } else {
          this.$bus.emit('service:change', that.defaultService)
          this.$engine.user.currentService.name = that.defaultService
          this.$engine.user.currentService.id = this.$engine.services.getServiceIdByName(that.defaultService)
        }
      }
    })
    this.$bus.$on('logout', function (force) {
      this.$engine.auth.logout(force).then(response => {
        that.connected = false
        this.$engine.user.currentService.name = ''
        this.$bus.$emit('service:change', '')
        reloadPage(that, {
          url: '/login/',
          force: true,
          ignoreCache: true
        })
      })
    })
    this.$bus.$on('isOnHomepage', function (currentlyOnHomepage) {
      that.homepageSelected = currentlyOnHomepage
    })

    for (let key in this.cssVars) {
      document.documentElement.style.setProperty(key, this.cssVars[key])
    }
  },
  computed: {
    cssVars () {
      return {
        '--actionButtonColor': this.design.global.actionButtonColor,
        '--actionButtonColorHover': this.design.global.actionButtonColorHover,
        '--actionTextColor': this.design.global.actionTextColor,
        '--actionTextColorHover': this.design.global.actionTextColorHover,
        '--filterBlocColor': this.design.global.filterBlocColor,
        '--filterTextColor': this.design.global.filterTextColor,
        '--headbandColor': this.design.menu.headbandColor,
        '--headbandTextColor': this.design.menu.headbandTextColor,
        '--headbandColorHover': this.design.menu.headbandColorHover,
        '--headbandTextColorHover': this.design.menu.headbandTextColorHover
      }
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    statusColor () {
      if (this.online) return ''
      return 'red'
    },
    titleNavBar () {
      let style = {
        'background-color': this.servicesColors.DEFAULT
      }
      if (!this.online) style['background-color'] = '#f44336'
      return style
    }
  },
  notifications: {
    showNetworkOffline: {
      type: 'error',
      title: '',
      message: 'Your device is offline'
    },
    showNetworkOnline: {
      type: 'info',
      title: '',
      message: 'Connection is now available'
    }
  },
  watch: {
    online (isOnline) {
      if (isOnline) {
        this.showNetworkOnline()
      } else {
        this.showNetworkOffline()
      }
    }
  },
  methods: {
    getContext () {
      let context
      if (this.$engine.user.get()) {
        switch (this.$engine.user.get().service_type) {
          case '0':
            context = 'generic'
            break
          case '1':
            context = 'KYC'
            break
          case '2':
            context = 'RTP'
            break
          case '3':
            context = 'DP'
            break
          case '4':
            context = 'Loan'
            break
          default:
            context = 'generic'
            break
        }
      } else {
        context = 'generic'
      }
      return context
    },
    getJsonFromUrl (url) {
      if (!url) url = location.href
      var question = url.indexOf('?')
      var hash = url.indexOf('#')
      if (hash === -1 && question === -1) return {}
      if (hash === -1) hash = url.length
      var query = (question === -1 || hash === question + 1) ? url.substring(hash) : url.substring(question + 1, hash)
      var result = {}
      query.split('&').forEach(function (part) {
        if (!part) return
        part = part.split('+').join(' ') // replace every + with space, regexp-free version
        var eq = part.indexOf('=')
        var key = eq > -1 ? part.substr(0, eq) : part
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : ''
        var from = key.indexOf('[')
        if (from === -1) result[decodeURIComponent(key)] = val
        else {
          var to = key.indexOf(']', from)
          var index = decodeURIComponent(key.substring(from + 1, to))
          key = decodeURIComponent(key.substring(0, from))
          if (!result[key]) result[key] = []
          if (!index) result[key].push(val)
          else result[key][index] = val
        }
      })
      return result
    }
  }
}
</script>

<style media="screen">
.hiddenBlock {
  display: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?3e46a10d